module.exports = __webpack_public_path__ + "static/media/shahzad.08c012bd.jpg";